<script>
import { Bar, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

export default {
  extends: Bar,
  mixins: [reactiveProp],
  props: {
    chartData: Object,
    maxTicks: Number,
  },
  data() {
    return {
      options: {
        hover: { mode: null },
        tooltips: {
          backgroundColor: "#fff",
          bodyFontColor: "#000",
          displayColors: false,
          borderColor: "rgba(38, 38, 62, 0.7)",
          borderWidth: "2",
          callbacks: {
            label: (labelObj) => {
              return `${labelObj.value}x`;
            },
            title: () => {
              return null;
            },
          },
        },
        layout: {
          padding: {
            top: 0,
            bottom: 0,
          },
        },
        scales: {
          yAxes: [
            {
              ticks: {
                min: 0,
                max: this.maxTicks,
                fontColor: "white",
                fontStyle: "bold",
                fontSize: 14,
                stepSize: 1,
                maxTicksLimit: 2,
              },
              gridLines: {
                display: false,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                fontColor: "white",
              },
              gridLines: {
                borderDash: [4, 2],
                color: "#fff",
                display: true,
                drawBorder: false,
              },
            },
          ],
        },
        legend: {
          display: false,
        },
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
};
</script>
